import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `/chat/${_ctx.id}`,
    class: "asButtonChat",
    "data-analytics": "",
    "data-analytics-element-type": "other",
    "data-analytics-element-id": "day_expert"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.$t('openChatWithExperts')), 1)
      ])
    ]),
    _: 3
  }, 8, ["to"]))
}